import axios from "axios";
import Links from "../constants/Links";

const buildParams = ({ sessionId, semesterId, standaloneFeeId, studentQuery } = {}) => {
    const params = { session: sessionId };

    if (semesterId != null) {
        params.semester = semesterId;
    }
    if (standaloneFeeId != null) {
        params.standalone_fee = standaloneFeeId;
    }
    if (studentQuery && studentQuery.trim()) {
        params.student = studentQuery.trim();
    }

    return params;
};

const StandalonePaymentManagement = {
    items: async (filters) => {
        const params = buildParams(filters);
        delete params.standalone_fee;
        delete params.student;
        return axios.get(Links.standalonePaymentManagement.items, { params });
    },

    payments: async (filters, offset = 0, size = 25) => {
        return axios.get(Links.standalonePaymentManagement.payments, {
            params: { ...buildParams(filters), offset, size },
        });
    },

    statistics: async (filters) => {
        return axios.get(Links.standalonePaymentManagement.statistics, {
            params: buildParams(filters),
        });
    },

    downloadReport: async (filters) => {
        return axios.get(Links.standalonePaymentManagement.report, {
            params: buildParams(filters),
            responseType: "blob",
        });
    },
};

export default StandalonePaymentManagement;
